import { render } from "./ProductModelSettings.vue?vue&type=template&id=00c927ca"
import script from "./ProductModelSettings.vue?vue&type=script&lang=js"
export * from "./ProductModelSettings.vue?vue&type=script&lang=js"

import "./ProductModelSettings.vue?vue&type=style&index=0&id=00c927ca&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});
